module.exports = __webpack_public_path__ + "img/spain-liver-cancer-male.b50bd779.png";